function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
import React, { memo, useContext, useEffect, useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { AppContext } from 'context';
import App from 'modules/App';
import messages from '../../../../messages';
import styles from './CurrentVersion.pcss';
const CurrentVersion = ()=>{
    useStyles(styles);
    const { currentVersion, releaseDate, changelogUrl } = useContext(AppContext);
    const [relDate, setRelDate] = useState(releaseDate);
    const currentLocale = useSelector(App.selectors.locale);
    const momentDate = moment.unix(new Date(releaseDate).getTime() / 1000);
    useEffect(()=>{
        setRelDate(momentDate.format('L'));
    }, [
        currentLocale
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.currentVersion,
        children: /*#__PURE__*/ _jsx("div", {
            className: "row align-items-left",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "col pl-10",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.currentVersion__versionName,
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.labels.currentVersion)),
                            ": ",
                            currentVersion
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: styles.currentVersion__releaseDate,
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.labels.releaseDate)),
                            ": ",
                            relDate
                        ]
                    }),
                    /*#__PURE__*/ _jsx("a", {
                        href: changelogUrl,
                        target: "_blank",
                        className: styles.currentVersion__changeLogUrl,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.sidebar.labels.seeChangeLog))
                    })
                ]
            })
        })
    });
};
export default /*#__PURE__*/ memo(CurrentVersion);
